import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/images/logo.png'
import { URL } from '../../constants'


const Logo = (props: any) => {
  const size = {
    width: props.width || '52px',
    height: props.height || 'auto'
  }

  const text = {
    color: props.textColor || '#11142d',
    fontSize: props.textSize || '36px',
    fontWeight: props.textWeight || 'bold',
    textDecoration: 'none'
  }

  return (
    <div className='d-flex'>
      <Link to={props.link || URL.home} className='d-flex align-items-center me-0'>
        <img src={logo} alt='logo' style={size} />
      </Link>
    </div>
  )
}

export default Logo
